'use client';

import { useEffect } from 'react';

import { sweepForeignTranscriptKeys } from '@/lib/storage/transcript-keys';
import { getSupabaseBrowserClient } from '@/lib/supabase/client';

/**
 * Subscribes to Supabase auth events and sweeps localStorage transcript keys
 * belonging to other users whenever the current authenticated identity is
 * established. Mounted once in the root layout so every sign-in entry point
 * (client OTP, server callback, invitation accept, anon→email promotion,
 * collision claim) is covered without per-handler instrumentation.
 *
 * Renders nothing.
 */
export function TranscriptSweepListener(): null {
  useEffect(() => {
    const supabase = getSupabaseBrowserClient();

    const {
      data: { subscription },
    } = supabase.auth.onAuthStateChange((event, session) => {
      // SIGNED_IN: client-side sign-in or anon promotion.
      // INITIAL_SESSION: client mount after a server-side auth flow (callback,
      // invitation accept). Fires once on subscribe with the current session.
      if ((event === 'SIGNED_IN' || event === 'INITIAL_SESSION') && session?.user.id) {
        sweepForeignTranscriptKeys(session.user.id);
      }
    });

    return () => subscription.unsubscribe();
  }, []);

  return null;
}
